<div class="outer-content">
  <form [formGroup]="questionForm" autocomplete="off" role="form" class="fieldHeight wh-auto">
    <div *ngIf="contentData && CMSData" class="float-left bg-white card-background1 wh-auto">
      <app-content-top-nav [visibleBackNav]='true' [enableBackNav]='true' (onBackClickHandler)="OnBackClick()"></app-content-top-nav>
      <!-- <div class="col-md-12 p-0">
          <h2 class="header">{{contentData.userDetails.Title}}</h2>
        </div> -->
      <div class="col-md-12 clear-all title-wrapper">
        <h1 class="title-text custom-header-h2 responsive-text-8" id="beforeYouStart-header">{{CMSData.string_BeforeYouContinueTitle}}</h1>
      </div>
      <div class="col-md-12 clear-all content-wrapper question-container">
        <p class="content-top mt-0" id="beforeYouStart-introduction">{{CMSData.string_RiskWarningWording}}</p>
        <!-- <div class="col-md-12 mar-t-30 bg-lightblue" *ngIf="!loginDetails">
          <p class="inner-content-data" id="beforeYouStart-noteStatement">{{CMSData.string_RegisterIfYouWantWording}}</p>
        </div>   -->
      </div>
      <!-- <app-text-input [pageName]="'questionForm'" [controllerData]="lnameTextCodeConfig" [parent]="questionForm" [controlName]="'letterPack'"
                formControlName="letterPack" (textChangeEventEmitter)="txtChange($event)">
              </app-text-input> -->
        <!-- <input type="text" class="number-input" value="0" maxlength="3" 
        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              [(ngModel)]="value" > -->
    <div class ="question-container">          
      <app-question [childId]="'letterPackQuestionary'" [questionConfig]="contentData.letterPackQuestion" [parent]="questionForm" [controlName]="'letterPack'"
        (toggleChange)="getToggleValue($event)"  (onDisplayMobileTooltipEmitter)="displayTooltipMessage()" >
      </app-question>
    </div> 
      <app-modal *ngIf="noPackValidatorFlag && !noWarningMSg" [modalConfig]="packAlertModalConfig" (closeModal)="closeNoPackModal()"
        (primaryBtnClick)="alertNoPackPrimaryBtnClick()" (dontShowUpMsgAgain)="dontShowUPMsgAgain($event)" [saveDataFlag]="false">
      </app-modal>
      <div class ="question-container">
        <app-question [childId]="'retirement-optionsQuestionary'" [questionConfig]="contentData.retirementOptionsQuestion" [parent]="questionForm"
          [controlName]="'retirementOptions'">
        </app-question>
      </div>
      <!-- <app-question [childId]="'pension-guidanceQuestionary'" [questionConfig]="contentData.pensionGuidanceQuestion" [parent]="questionForm" [controlName]="'pensionGuidance'">
      </app-question>
      <app-question [childId]="'financial-adviseQuestionary'" [questionConfig]="contentData.financialAdviserQuestion" [parent]="questionForm"
        [controlName]="'financialAdvise'">
      </app-question> -->

      <div class="col-md-12 underline margin-top">
      </div>
      <!-- <app-modal *ngIf="noPackValidatorFlag && !noWarningMSg" [modalConfig]="packAlertModalConfig" (closeModal)="closeNoPackModal()"
        (primaryBtnClick)="alertNoPackPrimaryBtnClick()" (dontShowUpMsgAgain)="dontShowUPMsgAgain($event)">
      </app-modal> -->
      <div class="bottom-container">
        <div class="float-left">
          <app-save [location]="'contentBottom'"></app-save>
        </div>
        <div class="float-right">
          <app-content-bottom-nav (onNextHandler)="gotoPersonalDetails()" [userInputDetail]="userInputDetail['buttonConfig']" [buttonType]="'normalCTA'"
            [disabled]="nextButtonDisabled"></app-content-bottom-nav>
        </div>
      </div>

      <app-modal *ngIf="displayTooltipAlert" [modalConfig]="tooltipModalConfig" (closeModal)="closeModal()" (primaryBtnClick)="alertTooltipPrimaryBtnClick($event)"
      (secondaryBtnClick)="alertSecondaryBtnClick()" [tooltipFlag]="true"></app-modal>
    </div>
  </form>
</div>